"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_aws_s3_1 = __importDefault(require("./react-aws-s3"));
exports.default = react_aws_s3_1.default;
